import React from 'react';
import UploadInsuranceDocuments from '../Shared/Insurance/UploadInsuranceDocuments';

function UploadHandlers(): React.ReactElement {
    return (
        <>
            <UploadInsuranceDocuments />
        </>
    );
}

export default UploadHandlers;
